import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DeliveryDestinationNote } from 'customers';

// Nota del destino della proposta, in sola lettura
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-delivery-note-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title class="note-header">
      <span class="title-medium-emphasized">{{ 'orders.ui.dettaglioNota' | transloco }}</span>
      <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.chiudi' | transloco" mat-dialog-close>
        <i class="fa-regular fa-xmark"></i>
      </button>
    </h2>
    <mat-dialog-content>
      <div class="note-box">
        <span class="body-small">{{ 'orders.ui.notaLibera' | transloco }}</span>
        <span class="body-small-emphasized">{{ data.notaLibera || ' - ' }}</span>
        <span class="body-small">{{ 'orders.ui.orari' | transloco }}</span>
        <span class="body-small-emphasized">{{ data.orari || ' - ' }}</span>
        <span class="body-small">{{ 'orders.ui.contatto' | transloco }}</span>
        <span class="body-small-emphasized">{{ data.contatto || ' - ' }}</span>
        <span class="body-small">{{ 'orders.ui.sponda' | transloco }}</span>
        <span class="body-small-emphasized">{{ data.sponda ? (('orders.ui.si' | transloco)) : (('orders.ui.no' | transloco)) }}</span>
      </div>
    </mat-dialog-content>
  `,
  styles: `
    .note-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .note-box {
      display: flex;
      flex-direction: column;
      gap: var(--mat-sys-spacing-4);
      padding: var(--mat-sys-spacing-16);
      border-radius: var(--mat-sys-corner-medium);
      background-color: var(--mat-sys-primary-container);
    }
  `,
})
export class DeliveryNoteDialog {
  readonly data = inject<DeliveryDestinationNote>(MAT_DIALOG_DATA);
}
